import React from 'react';
import { FiUser, FiUsers } from 'react-icons/fi';
import './ModeToggle.css';

const ModeToggle = ({ isBulkMode, onToggle, disabled = false }) => {
  const handleToggle = () => {
    if (!disabled) {
      onToggle(!isBulkMode);
    }
  };

  return (
    <div className="mode-toggle-container">
      <div className={`mode-toggle ${disabled ? 'disabled' : ''}`} onClick={handleToggle}>
        <div className={`toggle-option ${!isBulkMode ? 'active' : ''}`}>
          <FiUser className="toggle-icon" />
          <span className="toggle-label">Individual</span>
        </div>
        <div className={`toggle-option ${isBulkMode ? 'active' : ''}`}>
          <FiUsers className="toggle-icon" />
          <span className="toggle-label">Bulk Upload</span>
        </div>
        <div className={`toggle-slider ${isBulkMode ? 'bulk' : 'individual'}`}></div>
      </div>
      <div className="mode-description">
        {isBulkMode 
          ? 'Upload multiple registrations via CSV/Excel files' 
          : 'Register one student/staff member at a time'
        }
      </div>
    </div>
  );
};

export default ModeToggle;
